<div class="container-range">
    <div
        flowRange
        [relevantValues]="relevantValues"
        [newSelectionValues]="newSelectionValues"
        (temperatureValuesChange)="onTemperatureValuesChange($event)"
        name="range-slider">
    </div>
</div>